// ============ MS-WIFI Opportinity ==============

export const getWiredLANIntegrationOptions = () => [
    { label: "Yes", value: "111260000" },
    { label: "No", value: "111260001" }
];

export const getTypeOfWiredLANSetupOptions = () => [
    { label: "Existing", value: "111260000" },
    { label: "New", value: "111260001" }
];

export const getExistingWiFiCablingByCustomerOptions = () => [
    { label: "Yes", value: "111260000" },
    { label: "No", value: "111260001" }
];

export const getAPIIntegrationRequiredOptions = () => [
    { label: "Yes", value: "111260000" },
    { label: "No", value: "111260001" }
];

export const getBuildingAndFloorPlanOptions = () => [
    { label: "Yes", value: "111260000" },
    { label: "No", value: "111260001" }
];

export const getPMSVendorForAPIIntegrationOptions = () => [
    { label: "Yes", value: "111260000" },
    { label: "No", value: "111260001" }
];

export const getNetworkSecurityRequiredOptions = () => [
    { label: "Firewall", value: "111260000" },
    { label: "UTM", value: "111260001" },
    { label: "No", value: "111260002" }
];

export const getAnyIOTDevicesToBeConnectedOptions = () => [
    { label: "Yes", value: "111260000" },
    { label: "No", value: "111260001" }
];

export const getExistingNetworkSecurityDeviceOptions = () => [
    { label: "Yes", value: "111260000" },
    { label: "No", value: "111260001" }
];

export const getSeparateNetworkForBackOfficeOptions = () => [
    { label: "Yes", value: "111260000" },
    { label: "No", value: "111260001" }
];

export const getBandwidthRequiredOptions = () => [
    { label: "No", value: "111260000" },
    { label: "Yes", value: "111260001" }
];

export const getBandwidthTypeOptions = () => [
    { label: "Site-Level: Dedicated Bandwidth", value: "111260000" },
    { label: "Site-Level: Broadband", value: "111260001" },
    { label: "User Level: Per User", value: "111260002" }
];

export const getCountOfExistingInternetLinksOptions = () => [
    { label: "1", value: "111260000" },
    { label: "2", value: "111260001" },
    { label: "3", value: "111260002" },
    { label: "4", value: "111260003" }
];

export const getTypeOfExistingInternetLinkOptions = () => [
    { label: "ILL", value: "111260000" },
    { label: "Broadband", value: "111260001" }
];




// =========== MS_WIFI CAF ==============

export const getUserTypeOptions = () => [
    { label: "Base Plan", value: "111260000" },
    { label: "User 2", value: "111260001" },
    { label: "User 3", value: "111260002" },
    { label: "User 4", value: "111260003" },
    { label: "Visitor", value: "111260004" },
    { label: "Event", value: "111260005" }
];

export const getSpeedPerUserOptions = () => [
    { label: "Upto 5 Mbps", value: "111260000" },
    { label: "Upto 10 Mbps", value: "111260001" },
    { label: "Upto 15 Mbps", value: "111260002" },
    { label: "Upto 20 Mbps", value: "111260003" },
    { label: "Upto 30 Mbps", value: "111260004" },
    { label: "Upto 40 Mbps", value: "111260005" },
    { label: "Upto 50 Mbps", value: "111260006" },
    { label: "Upto 75 Mbps", value: "111260007" },
    { label: "Upto 100 Mbps", value: "111260008" }
];

export const getPlanValidityDataVolumeCriteriaOptions = () => [
    { label: "Per Day", value: "111260000" },
    { label: "Per Month", value: "111260001" }
];

export const getLoginMechanismOptions = () => [
    { label: "Username & Password", value: "111260000" },
    { label: "Username & Password with Additional Authentication", value: "111260001" },
    { label: "RMN & One-Time Password(OTP)", value: "111260002" },
    { label: "MAC Authentication", value: "111260003" }
];

///////////////////////////////

export const getUserManagementThroughPortalOptions = () => [
    { label: "No", value: "111260000" },
    { label: "Yes", value: "111260001" }
];

export const getReportRequiredOnUMPOptions = () => [
    { label: "No", value: "111260000" },
    { label: "Yes", value: "111260001" }
];

export const getDashboardRequiredOptions = () => [
    { label: "No", value: "111260000" },
    { label: "Yes", value: "111260001" }
];


